// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"22792a01","532":"9ebfb787","675":"e1eee9c9","805":"dea378f4"}[chunkId] + ".chunk.css";
};